import { Link } from 'react-router-dom'

import { Icon } from '@carrent/ui'

/**
 * Ссылка «история» из карточки сущности.
 *
 * Ведёт на экран журналов с преднастроенным фильтром. Фильтры живут
 * в URL именно ради этого: иначе пришлось бы либо дублировать выборку
 * в каждой карточке, либо заставлять человека собирать фильтр руками,
 * зная внутренний тип сущности.
 */
export function HistoryLink({ entityType, entityId, label = 'История', className = '' }) {
  if (!entityType || entityId == null) return null

  const params = new URLSearchParams({
    stream: 'audit',
    entity_type: entityType,
    entity_id: String(entityId),
    // История объекта редко укладывается в неделю: показываем всё,
    // иначе ссылка чаще ведёт на пустой экран.
    period: '',
  })

  return (
    <Link to={`/admin/logs?${params}`} className={`btn btn--ghost btn--sm ${className}`}>
      <Icon name="file" size={14} />
      {label}
    </Link>
  )
}

/** История действий конкретного пользователя. */
export function UserHistoryLink({ userId, label = 'История действий', className = '' }) {
  if (!userId) return null

  const params = new URLSearchParams({ stream: 'audit', user_id: userId, period: '' })

  return (
    <Link to={`/admin/logs?${params}`} className={`btn btn--ghost btn--sm ${className}`}>
      <Icon name="file" size={14} />
      {label}
    </Link>
  )
}
